// core/context.ts
var providerInstance = null;
function setProviderInstance(provider) {
  providerInstance = provider;
}
function getProviderInstance() {
  return providerInstance;
}
function setTenantContext(context) {
  if (!providerInstance) return;
  providerInstance.setTenant(context);
  if (context.tenantId) {
    providerInstance.setTag("tenant_id", context.tenantId);
  }
  if (context.tenantHandle) {
    providerInstance.setTag("tenant_handle", context.tenantHandle);
  }
  if (context.clubId) {
    providerInstance.setTag("club_id", context.clubId);
  }
}
function setUserContext(context) {
  if (!providerInstance) return;
  providerInstance.setUser(context);
  if (context?.id) {
    providerInstance.setTag("user_id", context.id);
  }
  if (context?.role) {
    providerInstance.setTag("user_role", context.role);
  }
}
function setClientContext(context) {
  if (!providerInstance) return;
  providerInstance.setContext("client", context);
  providerInstance.setTag("client_app", context.app);
  if (context.platform) {
    providerInstance.setTag("client_platform", context.platform);
  }
  if (context.version) {
    providerInstance.setTag("client_version", context.version);
  }
}
function setRequestContext(context) {
  if (!providerInstance) return;
  providerInstance.setRequest(context);
  if (context.requestId) {
    providerInstance.setTag("request_id", context.requestId);
  }
  if (context.route) {
    providerInstance.setTag("route", context.route);
  }
  if (context.method) {
    providerInstance.setTag("method", context.method);
  }
}
function addBreadcrumb(category, message, data, level) {
  if (!providerInstance) return;
  const breadcrumb = {
    category,
    message,
    level: level || "info",
    data,
    timestamp: Date.now()
  };
  providerInstance.addBreadcrumb(breadcrumb);
}
function clearContext() {
  if (!providerInstance) return;
  providerInstance.setUser(null);
  providerInstance.setContext("tenant", null);
  providerInstance.setContext("client", null);
  providerInstance.setContext("request", null);
}
function withIsolationScope(fn) {
  return providerInstance && typeof providerInstance.withIsolationScope === "function" ? providerInstance.withIsolationScope(fn) : fn();
}
function obfuscateEmail(email) {
  const [local, domain] = email.split("@");
  if (!domain) return "***";
  return `${local.substring(0, 2)}***@${domain}`;
}
function obfuscatePhone(phone) {
  if (phone.length < 4) return "***";
  return `***${phone.slice(-4)}`;
}

export { addBreadcrumb, clearContext, getProviderInstance, obfuscateEmail, obfuscatePhone, setClientContext, setProviderInstance, setRequestContext, setTenantContext, setUserContext, withIsolationScope };
//# sourceMappingURL=chunk-Z2R6UR6G.js.map
//# sourceMappingURL=chunk-Z2R6UR6G.js.map